/* 🤖 this file was generated by script */
export const wiconLogOut04 = {
  name: 'log_out_04',
  data: `<svg viewBox="0 0 24 24"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M18 8l4 4m0 0l-4 4m4-4H9m6-7.8A8.38 8.38 0 0010.67 3C5.88 3 2 7.03 2 12s3.88 9 8.67 9c1.58 0 3.06-.44 4.33-1.2"/></svg>`,
};
